<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
  >
    <v-card>
      <v-card-title>
        {{ $t('Components.Dialogs.CancelSubscription.Title') }}
        <v-spacer />
        <v-icon
          :aria-label="$t('General.Buttons.Close')"
          @click="$emit('close',false)"
        >
          mdi-close
        </v-icon>
      </v-card-title>

      <v-card-text class="text-center">
        {{ $t('Components.Dialogs.CancelSubscription.Text', [cancelMessageSubject]) }}
        <div>&nbsp;</div>
        <div>{{ $t('Components.Dialogs.CancelSubscription.CancellationEffectiveFrom') }}</div>
        <div><b>{{ new Date().toDateString() }}</b></div>
      </v-card-text>
      <v-card-text class="text-center">
        <div class="error--text">
          {{ $t('Components.Dialogs.CancelSubscription.PermanentAction') }}
        </div>
      </v-card-text>
      <v-card-text class="pb-6 pt-12 text-center">
        <v-btn
          class="mr-3"
          text
          @click.stop="$emit('close',false)"
        >
          {{ $t('General.Buttons.Close') }}
        </v-btn>

        <debounce-v-btn
          color="error"
          text
          @click="cancelSub()"
        >
          {{ $t('General.Buttons.CancelEntity', ['Subscription']) }}
        </debounce-v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'CancelSubscriptionDialog',
    props: {
      subscriptionToCancel: {
        type: Object,
        required: false,
        default: null,
      },
      visible: {
        type: Boolean,
        required: true,
        default: false,
      },
    },
    data: () => ({
      dialog: false,
    }),
    computed: {
      ...mapGetters(['getProductNameByVariantId', 'getCustomerName']),
      cancelMessageSubject () {
        return !this.subscriptionToCancel
          ? null
          : this.getProductNameByVariantId(this.subscriptionToCancel.productVariantId) +
            ' for ' +
            this.getCustomerName(this.subscriptionToCancel.customerId)
      },
    },
    watch: {
      visible: function () {
        this.dialog = this.visible
      },
      dialog: function (value) {
        if (!value) {
          this.$emit('close', false)
        }
      },
    },
    mounted: function () {
    },
    methods: {
      cancelSub () {
        this.$store.dispatch('cancelSubscription', this.subscriptionToCancel.uid)
        this.$emit('close', true)
      },
    },
  }
</script>

<style lang="scss">
</style>
